/**
 * @file test-case-version.ts
 * @description Конфигурация объекта версии тест-кейса для системы управления задачами.
 * Определяет настройки для сущности TestCaseVersion, включая заголовок,
 * форму редактирования, вкладки и конфигурацию модального окна поиска.
 * Поддерживает возможность добавления групп и организации версий тестов.
 * Интегрируется с формой TestCaseVersionForm для создания и редактирования.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [@forms/test-case-version, @src/types, @forms/test-case-version/tabs]
 * @related-files [@forms/test-case-version/index.ts, @forms/test-case-version/tabs/Main.tsx]
 */

import { TestCaseVersionForm } from '@forms/test-case-version';
import { tabObject } from '@src/types';
import { Main } from '@forms/test-case-version/tabs';

export const title = 'Версия тест кейса';
export const searchModalTitle = 'Выбор версии тест кейса';
export const type = 'TestCaseVersion';
export const form = TestCaseVersionForm;
export const isCanAddGroups = true;
export const tabs: tabObject[] = [{ label: 'Обзор', component: Main }];
